// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"09ec33fe","453":"faa2d13e"}[chunkId] + ".chunk.js";
};